/* eslint-disable*/

import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Box, Link, Button, Drawer, Typography, Avatar, Stack, Divider, IconButton, Tooltip } from '@mui/material';
import NotFound from '../../../pages/Page404';
// mock
import account from '../../../_mock/account';
// hooks
import useResponsive from '../../../hooks/useResponsive';
// components
import Logo from '../../../components/logo';
import Scrollbar from '../../../components/scrollbar';
import NavSection from '../../../components/nav-section';
//
import navConfig from './config';
import { ROLES } from 'src/utils/enums';
import { LogOutIcon } from 'lucide-react';
import Swal from 'sweetalert2';

// ----------------------------------------------------------------------

const NAV_WIDTH = 200;

const StyledAccount = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));

// ----------------------------------------------------------------------

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function Nav({ openNav, onCloseNav }) {
  const { pathname } = useLocation();
  console.log(pathname);
  const user = localStorage.getItem('technisches');
  const userData = JSON.parse(user);
  console.log(userData?.user);
  const basePath = pathname.split('/').slice(0, 2).join('/');
  console.log(basePath);
  const isValidPath = userData?.user?.nav?.includes(basePath);
  console.log(userData?.user?.role?.name === ROLES.OWNER);
  console.log(userData?.user?.role?.name);
  console.log(ROLES.OWNER);
  // If path is not valid, show Not Found screen or redirect to a NotFound component
  if (
    userData?.user?.role?.name.trim() !== ROLES.OWNER.trim() &&
    userData?.user?.role?.name.trim() !== ROLES.ADMIN.trim()
  ) {
    console.log('OUTER IF');
    if (!isValidPath) {
      return <NotFound />; // Or use <Redirect to="/notfound" /> if using react-router v6
    }
  }
  // eslint-disable-next-line
  const isDesktop = useResponsive('up', 'lg');
  // eslint-disable-next-line
  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
  }, [pathname]);

  const handleLogout = () => {
    Swal.fire({
      title: 'Are you sure you want to logout?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, logout',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem('technisches');
        window.location.href = '/login';
        // navigate('/login', { replace: true });
      }
    });
  };

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
    >
      <Box sx={{ px: 2.5, py: 3, display: 'inline-flex', justifyContent: 'center' }}>
        <Logo />
      </Box>
      <Divider />
      <Box sx={{ my: 1.5, px: 2.5 }}>
        <Typography variant="subtitle2" noWrap>
          {userData?.user?.email}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mt: 0.3,
          }}
        >
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {userData?.user?.role?.name?.toUpperCase()}
          </Typography>
          <Tooltip title="Logout" arrow>
            <IconButton onClick={handleLogout}>
              <LogOutIcon style={{ cursor: 'pointer' }} size={17} color="#1E3A5F" />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      <Divider />

      <NavSection data={navConfig} />

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV_WIDTH },
      }}
    >
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
              bgcolor: 'background.default',
              borderRightStyle: 'dashed',
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: { width: NAV_WIDTH },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
